import React, { FC, useEffect, useState } from "react";

import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";

import { pushAPIError } from "../../../slices/notifications";
import { useDispatch } from "../../../store";
import {
  useCreateBillingPortalSessionMutation,
  useGetPaymentInformationQuery,
} from "../../../store/pomeriumApi";
import UpdateBillingCustomerInformationDialog from "./UpdateBillingCustomerInformationDialog";

type PaymentInformationProps = {
  organizationId?: string;
};

const PaymentInformation: FC<PaymentInformationProps> = ({
  organizationId,
}) => {
  const dispatch = useDispatch();
  const [createBillingPortalSession] = useCreateBillingPortalSessionMutation();
  const { data: paymentInformation, error } = useGetPaymentInformationQuery(
    organizationId || "",
    { skip: !organizationId },
  );
  const [showUpdateCustomerInformation, setShowUpdateCustomerInformation] =
    useState(false);

  useEffect(() => {
    if (error) {
      dispatch(pushAPIError(error));
    }
  }, [error]);

  const onEdit = (evt: React.MouseEvent, deepLink: "" | "payment_method") => {
    evt.preventDefault();

    if (organizationId) {
      (async () => {
        const result = await createBillingPortalSession({
          createBillingPortalSessionRequest: {
            returnUrl: location.href,
            deepLink: deepLink,
          },
          organizationId,
        });
        if ("data" in result && result.data) {
          location.href = result.data.url;
        }
      })();
    }
  };
  const onEditEmail = (evt: React.MouseEvent) => {
    evt.preventDefault();

    setShowUpdateCustomerInformation(true);
  };
  const onCloseShowUpdateCustomerInformation = () => {
    setShowUpdateCustomerInformation(false);
  };

  return (
    <Stack>
      <UpdateBillingCustomerInformationDialog
        organizationId={organizationId}
        open={showUpdateCustomerInformation}
        onClose={onCloseShowUpdateCustomerInformation}
      />
      <Typography variant="h4">Payment Information</Typography>
      <TableContainer>
        <Table>
          <TableBody>
            {paymentInformation?.paymentMethod && (
              <TableRow>
                <TableCell variant="head">Payment method</TableCell>
                <TableCell>
                  {paymentInformation?.paymentMethod === "card" &&
                  paymentInformation?.card
                    ? `${paymentInformation?.card?.brand} ending in ${paymentInformation?.card?.last4}`
                    : paymentInformation?.paymentMethod}
                </TableCell>
                <TableCell align="right">
                  <Button onClick={(evt) => onEdit(evt, "payment_method")}>
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            )}
            {paymentInformation?.billingEmail && (
              <TableRow>
                <TableCell variant="head">Billing email</TableCell>
                <TableCell>{paymentInformation?.billingEmail}</TableCell>
                <TableCell align="right">
                  <Button onClick={onEditEmail}>Edit</Button>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};
export default PaymentInformation;
